import { AppLayout } from 'modules/app/components/templates/app-layout/AppLayout';
import { createBrowserRouter } from 'react-router-dom';
import { NotFound } from 'modules/app/components/pages/not-found/NotFound';
import { RouteBoundary } from 'modules/app/components/molecules/route-boundary/RouteBoundary';
import { routes } from './route-paths';
import { ConfiguredRedirectUri } from 'auth';
import { AuthenticatedRoute } from 'components/molecules/authenticated-route/AuthenticatedRoute';

export const createRouter = (basename: string) =>
  createBrowserRouter(
    [
      {
        path: routes.authIms,
        element: <ConfiguredRedirectUri />
      },
      {
        element: <AppLayout />,
        children: [
          {
            index: true,
            // Defaulted to authenticated route to redirect to ims for now
            element: <AuthenticatedRoute />
          },
          {
            path: routes.dashboard,
            lazy: async () => {
              const { Dashboard } = await import('modules/dashboard/Dashboard');
              return {
                Component: () => (
                  <RouteBoundary>
                    <Dashboard />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: routes.investments,
            lazy: async () => {
              const { ClientInvestments } = await import('modules/investments/Investments');
              return {
                Component: () => (
                  <RouteBoundary>
                    <ClientInvestments />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: routes.details,
            lazy: async () => {
              const { ClientDetails } = await import('modules/details/Details');
              return {
                Component: () => (
                  <RouteBoundary>
                    <ClientDetails />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: routes.transact,
            lazy: async () => {
              const { Transact } = await import('modules/transact/Transact');
              return {
                Component: () => (
                  <RouteBoundary>
                    <Transact />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: routes.tracking,
            lazy: async () => {
              const { Tracking } = await import('modules/tracking/Tracking');
              return {
                Component: () => (
                  <RouteBoundary>
                    <Tracking />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: routes.correspondence,
            lazy: async () => {
              const { Correspondence } = await import('modules/correspondence/Correspondence');
              return {
                Component: () => (
                  <RouteBoundary>
                    <Correspondence />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: routes.settings,
            lazy: async () => {
              const { Settings } = await import('modules/settings/Settings');
              return {
                Component: () => (
                  <RouteBoundary>
                    <Settings />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: routes.legal,
            lazy: async () => {
              const { Legal } = await import('modules/legal/Legal');
              return {
                Component: () => (
                  <RouteBoundary>
                    <Legal />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: routes.comingSoon,
            lazy: async () => {
              const { ComingSoon } = await import('modules/coming-soon/ComingSoon');
              return {
                Component: () => (
                  <RouteBoundary>
                    <ComingSoon />
                  </RouteBoundary>
                )
              };
            }
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      }
    ],
    { basename }
  );
